import type { StrokePoint } from "./pen-stroke";

/**
 * 直線モードのアンカー以降を切り詰め、終端を 1 点だけ追加した新しい点列を返す。
 */
export function appendShiftLinePoint(
  points: readonly StrokePoint[],
  anchorIndex: number,
  endPoint: StrokePoint
): StrokePoint[] {
  if (anchorIndex < 0 || anchorIndex >= points.length) return [...points];
  return [...points.slice(0, anchorIndex + 1), endPoint];
}

/**
 * 直線モード中のプレビューに使う、アンカーまでの点列と暫定終端を返す。
 */
export function resolveShiftLinePreviewPoints(
  points: readonly StrokePoint[],
  anchorIndex: number,
  previewPoint: StrokePoint | null
): readonly StrokePoint[] {
  if (anchorIndex < 0 || anchorIndex >= points.length) return points;
  if (previewPoint === null) return points.slice(0, anchorIndex + 1);
  return appendShiftLinePoint(points, anchorIndex, previewPoint);
}
